export function getLanguage () {
  let lang =
    navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.language
  lang = lang.split('-')[0]
  if (lang !== 'en' && lang !== 'es' && lang !== 'ru') {
    lang = 'ru'
  }
  return lang
}
